export default __webpack_public_path__ + "authBackground.png";